module.exports = __webpack_public_path__ + "img/logo-og.7a001d85.png";